import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataObject } from './models/report.model';
import { LocaleKeys } from './shared/templates/utils/template-display-sort-order.const';

@Injectable({ providedIn: 'root' })
export class DynamicLocaleService {
  translationKeyJson: { [localeId: number]: DataObject } = {};
  reportLocale: number;

  constructor(private http: HttpClient) {}

  setReportLocaleId(localeId: number) {
    this.reportLocale = localeId;
    this.getJsonData();
  }

  getReportLocaleId() {
    return this.reportLocale;
  }

  fetchJsonData() {
    return this.translationKeyJson[this.reportLocale];
  }

  private getJsonData() {
    if (!this.translationKeyJson[this.reportLocale]) {
      let localeIdPath = '/assets/reports-locales/locale-en-US.json';
      if (this.reportLocale === LocaleKeys.ChinaChinese) {
        localeIdPath = '/assets/reports-locales/locale-zh-CN.json';
      }
      this.http.get(localeIdPath).subscribe(data => {
        this.translationKeyJson[this.reportLocale] = data;
      });
    }
  }
}
